var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSurveySent = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 56,
    r: 56,
    fill: "#F0F5FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.176 38.8942L66.2698 81.096L26.2372 39.5515L97.176 38.8942Z",
    fill: "#DDE1E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.78 79.0345L66.271 81.0962L26.2384 39.5517L29.7053 39.522C68.2024 79.4614 36.7931 46.8714 67.78 79.0345Z",
    fill: "#8BB1F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.176 38.8942L47.6557 61.7756L37.936 73.0884L40.7802 54.643L97.176 38.8942Z",
    fill: "#B2B8C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7924 68.1498L37.9344 73.0886L47.6541 61.7759L53.7924 68.1498Z",
    fill: "#8288A1"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSurveySent, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/survey-sent.6435bef8.svg";
export { ForwardRef as ReactComponent };